import axios from 'axios';

const ACTIVITY_LOG_API = process.env.REACT_APP_ACTIVITY_LOG_API;  

const useActivityLogger = (performedBy, role) => {
  const log = async (action, options = {}) => {
    if (!performedBy) return;
    try {
      await axios.post(ACTIVITY_LOG_API, {
        action,
        performedBy,
        role,
        targetId:   options.targetId   || null,
        targetName: options.targetName || null,
        jdId:       options.jdId       || null,
        metadata:   options.metadata   || {},
      });
      console.log("activity logged",action)
    } catch (e) {
      console.warn("Activity log failed silently:", e.message);
    }
  };
  return { log };
};

export default useActivityLogger;